import { clientDashboardSlice } from './client-dashboard.slice';
import * as selectors from './selectors';
export const clientDashboardActions = {
  ...clientDashboardSlice.actions,
};

export const clientDashboardSelectors = {
  ...selectors,
};
